import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import App from './App';
import './i18n';

Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN ?? 'https://f7e6339b405e5b89b92eb09a392ef0b7@o344891.ingest.us.sentry.io/4511042507571200',
    environment: import.meta.env.MODE,
    enabled: import.meta.env.PROD,
    sendDefaultPii: true,
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(<App />);
